import React, { Component } from "react";
import homedata from "../../data/home.json";

class Contact extends Component {
  render() {
    let contactInfo = homedata.contact;
    let sectionHeadingInfo = contactInfo.sectionHeading;
    let phoneInfo = contactInfo.phone;
    let websiteInfo = contactInfo.website;
    let emailInfo = contactInfo.email;

    return (
      <section id="kontak" className="modern-contact-section pt100 pb100">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 offset-lg-2">
              <div className="section-title text-center mb60">
                <h2>
                  Hubungi <span>Kami</span>
                </h2>
                <hr className="lines" />
                <p className="section-description">
                  Kami siap membantu transformasi digital bisnis Anda
                </p>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-10 offset-lg-1">
              <div className="contact-info-wrapper">
                <div className="contact-info-card">
                  <div className="contact-icon">
                    <i className="pe-7s-map-marker"></i>
                  </div>
                  <div className="contact-details">
                    <h4>Alamat</h4>
                    <p>{sectionHeadingInfo.desc}</p>
                  </div>
                </div>

                <div className="contact-info-card">
                  <div className="contact-icon">
                    <i className="pe-7s-call"></i>
                  </div>
                  <div className="contact-details">
                    <h4>Telepon</h4>
                    <p>
                      <a href={`tel:${phoneInfo.replace(/\s/g, "")}`}>
                        {phoneInfo}
                      </a>
                    </p>
                  </div>
                </div>

                <div className="contact-info-card">
                  <div className="contact-icon">
                    <i className="pe-7s-global"></i>
                  </div>
                  <div className="contact-details">
                    <h4>Website</h4>
                    <p>
                      <a
                        href={websiteInfo}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {websiteInfo}
                      </a>
                    </p>
                  </div>
                </div>

                <div className="contact-info-card">
                  <div className="contact-icon">
                    <i className="pe-7s-mail"></i>
                  </div>
                  <div className="contact-details">
                    <h4>Email</h4>
                    <p>
                      <a href={`mailto:${emailInfo}`}>{emailInfo}</a>
                    </p>
                  </div>
                </div>
              </div>

              <div className="cta-wrapper text-center">
                <a href="mailto:info@quezio.com" className="btn-contact">
                  Kirim Email
                  <i className="fa fa-envelope"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <style jsx="true">{`
          .modern-contact-section {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            position: relative;
            color: white;
          }

          .section-title h2 {
            font-size: 42px;
            font-weight: 700;
            color: white;
            margin-bottom: 15px;
          }

          .section-title h2 span {
            color: #ffd700;
          }

          .section-description {
            font-size: 18px;
            color: rgba(255, 255, 255, 0.9);
            line-height: 1.8;
            margin-top: 15px;
          }

          .contact-info-wrapper {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
            gap: 25px;
            margin-bottom: 50px;
          }

          .contact-info-card {
            background: rgba(255, 255, 255, 0.15);
            backdrop-filter: blur(10px);
            border: 1px solid rgba(255, 255, 255, 0.2);
            border-radius: 16px;
            padding: 30px;
            display: flex;
            gap: 20px;
            align-items: flex-start;
            transition: all 0.3s ease;
          }

          .contact-info-card:hover {
            background: rgba(255, 255, 255, 0.25);
            transform: translateY(-5px);
            box-shadow: 0 15px 40px rgba(0, 0, 0, 0.2);
          }

          .contact-icon {
            flex-shrink: 0;
            width: 60px;
            height: 60px;
            border-radius: 12px;
            background: rgba(255, 255, 255, 0.2);
            display: flex;
            align-items: center;
            justify-content: center;
            border: 2px solid rgba(255, 255, 255, 0.3);
          }

          .contact-icon i {
            font-size: 28px;
            color: white;
          }

          .contact-details h4 {
            font-size: 18px;
            font-weight: 700;
            color: white;
            margin-bottom: 8px;
          }

          .contact-details p {
            font-size: 15px;
            line-height: 1.6;
            color: rgba(255, 255, 255, 0.9);
            margin: 0;
          }

          .contact-details a {
            color: rgba(255, 255, 255, 0.9);
            text-decoration: none;
            transition: color 0.3s ease;
          }

          .contact-details a:hover {
            color: #ffd700;
            text-decoration: underline;
          }

          .cta-wrapper {
            margin-top: 40px;
          }

          .btn-contact {
            display: inline-flex;
            align-items: center;
            gap: 10px;
            padding: 16px 40px;
            background: white;
            color: #667eea;
            border-radius: 50px;
            font-weight: 700;
            font-size: 16px;
            text-decoration: none;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
            transition: all 0.3s ease;
          }

          .btn-contact:hover {
            transform: translateY(-3px);
            box-shadow: 0 15px 40px rgba(0, 0, 0, 0.3);
            color: #667eea;
            text-decoration: none;
          }

          .btn-contact i {
            transition: transform 0.3s ease;
          }

          .btn-contact:hover i {
            transform: translateX(5px);
          }

          @media (max-width: 991px) {
            .section-title h2 {
              font-size: 32px;
            }

            .contact-info-wrapper {
              grid-template-columns: 1fr;
            }

            .contact-info-card {
              padding: 20px;
            }

            .contact-icon {
              width: 50px;
              height: 50px;
            }

            .contact-icon i {
              font-size: 24px;
            }
          }
        `}</style>
      </section>
    );
  }
}

export default Contact;
